/* camelcase */
export default {
    discount_type: ['required', 'trim', 'string'],
    discount_amount: ['required', 'trim', 'integer'],
};